export default "__VITE_ASSET__D_Ism_k8__"